export default "__VITE_ASSET__DTfIfvT4__"